import React, { createContext } from 'react';

export const RotationContext = createContext({
  enabled: false,
  toggle: () => {},
}); 